import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_BASE_URL } from '../../../config';

const Exit = () => {

  /* ================= STATES ================= */
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ exit_type: '' });
  const [editData, setEditData] = useState({ id: '', exit_type: '' });

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    axios.get(API_BASE_URL + '/exit_management', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      setTableData(res.data.data.exit || []);
    })
    .catch(() => toast.error('Failed to load data'));
  };

  /* ================= ADD EXIT ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/add_exit', formData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      toast.success(res.data.message);
      setFormData({ exit_type: '' });
      fetchData();
    })
    .catch(err => {
      toast.error(err.response?.data?.message || 'Error');
    });
  };

  /* ================= UPDATE EXIT ================= */
  const handleEditSubmit = (e) => {
    e.preventDefault();

    axios.post(API_BASE_URL + '/updateexit', editData, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => {
      toast.success(res.data.message);
      fetchData();
    });
  };

  /* ================= SEARCH ================= */
  const filteredData = tableData.filter(item =>
    item.exit_type?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  /* ================= DATATABLE STYLES ================= */
  const customStyles = {
    headCells: {
      style: {
        fontWeight: '600',
        fontSize: '13px',
        backgroundColor: '#f8f9fa',
      },
    },
    cells: {
      style: {
        fontSize: '13px',
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
    rows: {
      style: {
        minHeight: '42px',
      },
    },
  };

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    
    {
      name: 'Exit Name',
      selector: row => row.exit_type,
      sortable: true,
    },
    {
      name: 'Create Date',
      selector: row => row.date,
    },
    {
      name: 'Action',
      width: '100px',
      cell: row => (
        <button
          className="btn btn-icon btn-sm"
          data-toggle="modal"
          data-target="#editModal"
          onClick={() => setEditData(row)}
        >
          <i className="fa fa-edit" />
        </button>
      ),
    },
  ];

  return (
    <>
      <ToastContainer position='bottom-right' />

      <div className="section-body">
        <div className="container-fluid">

          {/* ================= ADD EXIT MANAGEMENT ================= */}
          <div className="card mb-4">
            <div className="card-body">
              <h3 className="card-title" style={{ color: '#e96827' }}>
                ADD EXIT MANAGEMENT
              </h3>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-4 required-tooltip">
                    <label>
                      Exit Name 
                    </label>
                    <input
                      type="text"
                      className="form-control required-input"
                      required
                      value={formData.exit_type}
                      onChange={e =>
                        setFormData({
                          exit_type: e.target.value.replace(/[^A-Za-z ]/g, ''),
                        })
                      }
                    />
                  </div>
                </div>

                <button className="btn btn-danger mt-3">
                  Save
                </button>
              </form>
            </div>
          </div>

          {/* ================= EXIT LIST ================= */}
          <div className="card">
            <div className="card-header d-flex align-items-center">
              <h3 className="card-title mb-0" style={{ color: '#e96827' }}>
                EXIT LIST
              </h3>

              <div className="ml-auto">
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Search..."
                  style={{ width: '220px' }}
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="card-body p-0">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                dense
                striped
                highlightOnHover
                responsive
                customStyles={customStyles}
              />
            </div>
          </div>

        </div>
      </div>

      {/* ================= EDIT MODAL ================= */}
      <div className="modal fade" id="editModal" tabIndex="-1">
        <form onSubmit={handleEditSubmit}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Exit</h5>
                <button className="close" data-dismiss="modal">×</button>
              </div>

              <div className="modal-body required-tooltip">
                <label>Exit Name</label>
                <input
                  type="text"
                  className="form-control required-input"
                  value={editData.exit_type || ''}
                  onChange={e =>
                    setEditData({ ...editData, exit_type: e.target.value })
                  }
                  
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button className="btn btn-danger">
                  Save
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default connect()(Exit);
